@if (isError) {
  <div class="h-[80%]">
    <app-something-went-wrong
      description="{{ 'cannotLoadDispatchingRules' | translate }}"
      [showPicture]="false"
      (retryEmitter)="retryData()"></app-something-went-wrong>
  </div>
}

@if (!isError) {
  <div class="flex-col-container-1">
    <div class="search-panel">
      <div class="button-group h-[40px]">
        <button
          mat-raised-button
          color="primary"
          class="page-block-button"
          aria-label="Create dispatching rule"
          (click)="openCreateModalForm()">
          <mat-icon class="{{ useMobileView ? '!m-0' : '' }}">add</mat-icon>
          {{ useMobileView ? '' : ('newDispatchingRule' | translate) }}
        </button>
        @if (isExporting) {
          <div class="w-[2.5rem]">
            <app-loader
              padding="0"
              [diameter]="'22'"
              height="100%"></app-loader>
          </div>
        } @else {
          <button
            mat-icon-button
            [attr.aria-label]="'exportExcel' | translate"
            (click)="exportExcel()"
            matTooltip="{{ 'exportExcel' | translate }}">
            <i class="far fa-file-excel fa-xs"></i>
          </button>
        }
      </div>
      <div class="search-bar">
        <app-search-bar
          [fullWidth]="useMobileView"
          (searchEventEmitter)="onSearch()"
          (valueChangedEventEmitter)="onSearchValueChanged($event)"
          [search]="searchValue"></app-search-bar>
        @if (!useMobileView) {
          <app-table-header
            [countTotal]="totalSize"
            (reloadEventEmitter)="reload()"
            [isReloadLoading]="isReloadLoading"></app-table-header>
        }
      </div>
    </div>
  </div>
}
@if (useMobileView) {
  <app-table-header
    [countTotal]="totalSize"
    (reloadEventEmitter)="reload()"
    (searchOrderChangeEventEmitter)="searchOrderChange($event)"
    (changeOrderEventEmitter)="changeOrder()"
    [searchOrder]="searchOrder"
    [searchOrders]="searchOrders"
    [orderDirection]="filter.orderDirection"
    [isReloadLoading]="isReloadLoading"></app-table-header>
  @if (!isLoading && !isError) {
    <div class="h-full">
      <app-infinity-scroll
        [isErrorScroll]="isErrorScroll"
        [isLoadingScroll]="isLoadingScroll"
        [canNavigateForward]="canNavigateForward"
        [dataLength]="dataSource.data.length"
        (loadData)="onScroll()"
        (refreshData)="refreshData()">
        <div class="mobile-container-cards">
          @if (!!dataSource.data.length) {
            @for (dispatchingRule of dataSource.data; track dispatchingRule) {
              <div>
                <div class="card">
                  <mat-card class="mobile-row">
                    <mat-card-content
                      (click)="openEditModalForm(dispatchingRule)"
                      class="flex flex-1 cursor-default">
                      <div class="card-table-row">
                        <div class="card-table-row-header">
                          {{ 'name' | translate }}:
                        </div>
                        <div class="card-table-row-value">
                          {{ dispatchingRule.dispatchingRule?.name ?? '' }}
                        </div>
                      </div>
                      <div class="card-table-row">
                        <div class="card-table-row-header">
                          {{ 'priority' | translate }}:
                        </div>
                        <div class="card-table-row-value">
                          {{ dispatchingRule.dispatchingRule?.priority ?? '' }}
                        </div>
                      </div>
                    </mat-card-content>
                    <div class="icons-mobile-block">
                      <button
                        mat-icon-button
                        matTooltip="{{
                          'editDispatchingRuleLabel' | translate
                        }}"
                        color="primary"
                        [attr.aria-label]="
                          'editDispatchingRuleLabel' | translate
                        "
                        (click)="openEditModalForm(dispatchingRule)">
                        <mat-icon>edit_outline</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        matTooltip="{{ 'delete' | translate }}"
                        color="primary"
                        aria-label="Delete"
                        (click)="
                          deleteDispatchingRule(
                            dispatchingRule?.dispatchingRuleId,
                            dispatchingRule?.dispatchingRule?.name
                          )
                        ">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </div>
                  </mat-card>
                </div>
              </div>
            }
          }
        </div>
        @if (!dataSource.data.length) {
          <app-no-data></app-no-data>
        }
      </app-infinity-scroll>
    </div>
  }
}
@if (!useMobileView && !isLoading && !isError) {
  <div class="settings-table-container h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <table
        matSort
        matSortDisableClear
        (matSortChange)="sortData($event)"
        mat-table
        [dataSource]="dataSource"
        class="w-full">
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'name' | translate }}
          </th>
          <td mat-cell *matCellDef="let dispatchingRules">
            {{ dispatchingRules.dispatchingRule.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="priority">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'priority' | translate }}
          </th>
          <td mat-cell *matCellDef="let dispatchingRules">
            {{ dispatchingRules.dispatchingRule.priority }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'actions' | translate }}</th>
          <td mat-cell *matCellDef="let dispatchingRules">
            <button
              mat-icon-button
              [attr.aria-label]="'editDispatchingRuleLabel' | translate"
              matTooltip="{{ 'editDispatchingRuleLabel' | translate }}"
              (click)="openEditModalForm(dispatchingRules)">
              <mat-icon>edit_outline</mat-icon>
            </button>
            <span class="mr-2"></span>
            <button
              mat-icon-button
              aria-label="Delete"
              matTooltip="{{ 'delete' | translate }}"
              (click)="
                deleteDispatchingRule(
                  dispatchingRules?.dispatchingRuleId,
                  dispatchingRules?.dispatchingRule?.name
                )
              ">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="cursor-default"></tr>
      </table>
      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (isLoading) {
  <div class="flex-1 overflow-hidden">
    <app-skeleton-table></app-skeleton-table>
  </div>
}

<ng-template #createDrawer>
  <app-dispatching-rule-create-or-update-dialog
    (closeEventEmitter)="onCloseEditModalForm()"
    (submitEventEmitter)="onSearch()"
    [updatingDispatchingRule]="editingDispatchingRule"
    [mailAccountId]="mailAccountId">
  </app-dispatching-rule-create-or-update-dialog>
</ng-template>
